Wee.fn.make('form', {
	init: function() {
		var priv = this.$private,
			$form = $('ref:submissionForm'),
			max = 500;


		Wee.infieldLabels.init();

		new Autogrow($('ref:message')[0]);

		// Show character count on story submission text area
		$('ref:characterCount').html(max + ' characters remaining');

		$.events.on({
			'ref:message': {
				keydown: function(e, el) {
					if (el.value.length >= 300 && e.keyCode !== 8) {
						el.value = el.value.slice(0, 300);
						e.preventDefault();
					}
				},
				keyup: function(e, el) {
					$('ref:characterCount').html((max - el.value.length) + ' characters remaining');
				}
			}
		});

		// Bind form submission
    	$form.on('submit', function(e, el) {
			var $el = $(el),
		 		$email = $el.find('ref:email'),
		 		$title = $el.find('ref:title');

				// Submit form via ajax
				$.fetch.request({
					method: 'post',
					type: 'form',
					data: $el.serialize(),
					json: true,
					success: function(response) {
						var success = response.success,
							errors = response.errors;

						// Reset error messages
						$('ref:errorMessage').text('');

						// Notify user of submission state
						if (! success && Object.keys(errors).length) {
							for (var error in errors) {
								priv.insertErrors(error, errors[error]);
							}
						} else {
							$el.prepend($.view.render('thankyou', {
								url: $.get('entryUrl'),
								text: $.get('entryText'),
								heading: $.get('storyHeading'),
								body: $.get('storyBody')
							}));
							$el.find('ref:close').hide();
							$('ref:close').hide();
							$el.find('ref:errorMessage').hide();
							$el.find('ref:characterCount').hide();
						}
					}
				});


            e.preventDefault();
        });
	}
}, {
	insertErrors: function(type, errors) {
		console.log(type, errors[0]);
		$('ref:' + type +'Error').text(errors[0]);
	}
});
